module.exports = __webpack_public_path__ + "img/new2.46c7b1e1.png";